__turbopack_context__.v({
  "buttonsWrapper": "ylvwYG_buttonsWrapper",
  "container": "ylvwYG_container",
  "content": "ylvwYG_content",
  "description": "ylvwYG_description",
  "dismiss": "ylvwYG_dismiss",
  "title": "ylvwYG_title",
});
